var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1486,
    height: 189,
    viewBox: "0 0 1486 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.706787 4.08032H76.5419C97.0053 4.08032 113.342 9.49712 125.551 20.3307C137.76 30.9923 143.865 45.867 143.865 64.9548C143.865 84.5584 137.76 99.6051 125.551 110.095C113.514 120.584 97.1773 125.829 76.5419 125.829H39.9141V184.382H0.706787V4.08032ZM70.8672 93.0705C93.0502 93.0705 104.142 83.6986 104.142 64.9548C104.142 54.4651 101.132 47.1567 95.1138 43.0297C89.2671 38.9026 81.1849 36.839 70.8672 36.839H39.9141V93.0705H41.4618H70.8672Z",
    fill: "url(#paint0_linear_16_12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.51 4.08032H266.667C287.13 4.08032 303.037 9.23917 314.386 19.5569C325.908 29.7026 331.669 44.4053 331.669 63.6651C331.669 77.0781 328.573 88.5135 322.383 97.9714C316.192 107.257 307.422 114.05 296.072 118.349L330.379 184.382H290.14L258.413 123.25H227.718V184.382H188.51V4.08032ZM259.703 90.4911C269.676 90.4911 277.501 88.3416 283.175 84.0425C289.022 79.7435 291.945 72.951 291.945 63.6651C291.945 53.8632 289.108 46.9848 283.433 43.0297C277.759 38.9026 269.848 36.839 259.703 36.839H227.718V90.4911H259.703Z",
    fill: "url(#paint1_linear_16_12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M477.621 188.251C459.565 188.251 443.142 184.296 428.354 176.386C413.737 168.476 402.215 157.47 393.789 143.369C385.363 129.096 381.15 112.76 381.15 94.3602C381.15 75.9603 385.363 59.624 393.789 45.3511C402.215 31.0783 413.737 19.9868 428.354 12.0765C443.142 4.16631 459.565 0.211182 477.621 0.211182C495.677 0.211182 511.927 4.16631 526.372 12.0765C540.989 19.9868 552.51 31.0783 560.936 45.3511C569.362 59.624 573.575 75.9603 573.575 94.3602C573.575 112.76 569.362 129.096 560.936 143.369C552.51 157.47 540.989 168.476 526.372 176.386C511.927 184.296 495.677 188.251 477.621 188.251ZM477.621 152.139C487.938 152.139 497.31 149.818 505.736 145.175C514.334 140.36 521.127 133.653 526.114 125.055C531.101 116.285 533.594 106.054 533.594 94.3602C533.594 82.8388 531.101 72.779 526.114 64.181C521.299 55.4109 514.592 48.7044 505.994 44.0614C497.568 39.2465 488.11 36.839 477.621 36.839C466.959 36.839 457.329 39.2465 448.731 44.0614C440.305 48.7044 433.598 55.4109 428.612 64.181C423.625 72.779 421.131 82.8388 421.131 94.3602C421.131 106.054 423.625 116.285 428.612 125.055C433.598 133.653 440.391 140.36 448.989 145.175C457.587 149.818 467.131 152.139 477.621 152.139Z",
    fill: "url(#paint2_linear_16_12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M626.72 4.08032H702.555C723.019 4.08032 739.355 9.49712 751.564 20.3307C763.774 30.9923 769.878 45.867 769.878 64.9548C769.878 84.5584 763.774 99.6051 751.564 110.095C739.527 120.584 723.191 125.829 702.555 125.829H665.927V184.382H626.72V4.08032ZM696.88 93.0705C719.063 93.0705 730.155 83.6986 730.155 64.9548C730.155 54.4651 727.146 47.1567 721.127 43.0297C715.28 38.9026 707.198 36.839 696.88 36.839H665.927V93.0705H696.88Z",
    fill: "url(#paint3_linear_16_12)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M819.53 4.08032H858.737V151.624H941.274V184.382H819.53V4.08032Z",
    fill: "url(#paint4_linear_16_12)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.94 4.08032H1091.38L1163.34 184.382H1123.36L1107.89 145.175H1036.44L1020.96 184.382H980.72L1052.94 4.08032ZM1107.89 145.175L1072.03 45.3511L1036.44 145.175H1107.89Z",
    fill: "url(#paint5_linear_16_12)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.72 4.08032H1305.19C1322.22 4.08032 1335.54 8.29338 1345.17 16.7195C1354.8 25.1456 1359.62 37.3549 1359.62 53.3474C1359.62 61.4296 1357.73 68.8239 1353.94 75.5304C1350.16 82.065 1345 87.1378 1338.47 90.749C1347.41 94.0163 1354.12 99.0032 1358.59 105.71C1363.06 112.244 1365.29 120.842 1365.29 131.504C1365.29 142.338 1362.8 151.795 1357.81 159.878C1353 167.788 1346.29 173.893 1337.69 178.192C1329.27 182.319 1319.9 184.382 1309.58 184.382H1216.72V4.08032ZM1297.71 77.336C1304.59 77.336 1310.01 75.6164 1313.96 72.1772C1317.92 68.7379 1319.9 63.2352 1319.9 55.6688C1319.9 47.4147 1317.92 41.7399 1313.96 38.6446C1310.18 35.5493 1304.33 34.0017 1296.42 34.0017H1255.93V77.336H1297.71ZM1300.03 154.461C1308.46 154.461 1314.82 152.827 1319.12 149.56C1323.59 146.121 1325.83 140.188 1325.83 131.762C1325.83 123.164 1323.51 116.973 1318.86 113.19C1314.39 109.407 1307.69 107.515 1298.74 107.515H1255.93V154.461H1300.03Z",
    fill: "url(#paint6_linear_16_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_12",
    x1: 1.1194,
    y1: 118.431,
    x2: 1484.22,
    y2: 82.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_12",
    x1: -23.8796,
    y1: 118.431,
    x2: 1459.22,
    y2: 82.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_12",
    x1: -38.8835,
    y1: 118.431,
    x2: 1444.22,
    y2: 82.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_12",
    x1: -58.8834,
    y1: 118.431,
    x2: 1424.22,
    y2: 82.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_12",
    x1: -78.8767,
    y1: 118.431,
    x2: 1404.22,
    y2: 82.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_12",
    x1: -98.8806,
    y1: 118.431,
    x2: 1384.22,
    y2: 82.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16_12",
    x1: -118.881,
    y1: 118.431,
    x2: 1364.22,
    y2: 82.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.d95406824e63e3b9b68166d1ad90f038.svg";
export { ForwardRef as ReactComponent };